import { useAuth } from '@contexts/index'
import { useFormContext } from 'react-hook-form'
import { upperCaseFirst } from '@utils/helpers/stringHelpers'

import { ToggleInput } from '../baseInputs'

const AuthFill = () => {
  const { setValue, trigger } = useFormContext()
  const user = useAuth()

  if (!user) {
    return null
  }

  const handleChange = (e) => {
    if (e.target.checked) {
      setValue('title', upperCaseFirst(user?.title))
      setValue('first_name', user?.firstName)
      setValue('last_name', user?.lastName)
      setValue('email', user?.email)
      trigger('title')
      trigger('first_name')
      trigger('last_name')
      trigger('email')
    }
  }

  return <ToggleInput user={user} onChange={handleChange} />
}

export default AuthFill
